import classNames from 'classnames'
import { NumberInput } from 'legacy/lut/components/common/numberInput/NumberInput'

import { useFocus } from 'core-components/hooks/useFocus'
import { IInputProps } from 'core-components/library/inputs'

import { onChangePercentField } from '../../../../helpers/changePercentField/onChangePercentField'
import { getPercentView } from '../../../../helpers/getPercentView'

import styles from './PercentInput.module.scss'

interface IProps extends Omit<IInputProps, 'onChange' | 'value'> {
  className?: string
  value?: number | string | null
  onChange: (value: number | null) => void
  withoutSign?: boolean
  max?: number | string
  min?: number | string
}
export const PercentInput = ({ value, onChange, withoutSign, ...props }: IProps) => {
  const { focused, onFocus, onBlur } = useFocus(0)

  if (focused) {
    return (
      <NumberInput
        {...props}
        classes={{
          inputClasses: {
            root: props.className,
          },
        }}
        value={value ? value.toString() : ''}
        onChange={onChangePercentField({ onChange })}
        onFocus={onFocus}
        onBlur={onBlur}
        autoFocus={true}
        align={'right'}
      />
    )
  }

  return (
    <div
      className={classNames(props.className, styles.beautifiedValue)}
      tabIndex={1}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {getPercentView(value != null ? Number(value) : null, withoutSign)}
    </div>
  )
}
